module.exports = __webpack_public_path__ + "img/tardrive.2302d91e.png";